export default {"src":"/developer/_next/static/media/tinkoff.ae60e30d.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};